import React from 'react';
import { Label, RadioGroup } from 'wix-rich-content-ui-components';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = ".WJUyi{display:flex;flex-direction:column;gap:16px}[dir] .WJUyi{margin-bottom:16px}.jXhu-{align-items:start;display:flex;flex-direction:column;gap:8px}[dir] .jXhu-{margin-bottom:16px}";
var styles = {"videoSettings_controls_labels":"WJUyi","videoSettings_controls_radioPanel":"jXhu-"};
styleInject(css_248z);

const ControlsSection = ({ t, theme, showControls = true, onChange }) => {
  const controlValues = { onHover: "onHover", never: "never" };
  const controlsOptions = [
    {
      value: controlValues.onHover,
      labelText: t("Media_Controls_Show_On_Hover"),
      dataHook: "videoShowOnHoverRadio"
    },
    {
      value: controlValues.never,
      labelText: t("Media_Controls_Show_Never"),
      dataHook: "videoShowNeverRadio"
    }
  ];
  const onRadioButtonChange = (value) => {
    onChange(value === controlValues.onHover);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: styles.videoSettings_controls_labels }, /* @__PURE__ */ React.createElement(Label, { label: t("Media_Controls_Label"), style: { fontSize: 16 } }), /* @__PURE__ */ React.createElement(Label, { label: t("Media_Controls_Subtitle") })), /* @__PURE__ */ React.createElement(
    RadioGroup,
    {
      theme,
      value: showControls ? controlValues.onHover : controlValues.never,
      onChange: onRadioButtonChange,
      dataSource: controlsOptions,
      className: styles.videoSettings_controls_radioPanel
    }
  ));
};

export { ControlsSection as default };
//# sourceMappingURL=ControlsSection.js.map
